<!--
 * @LastEditors: chuhongguang
 * @desc: 一维数据的表格
 * @场景: 因子数据详情组件内 / 重构右侧内容区域
-->
<template>
  <div>
    <div class="space_between" style="align-items: center;margin: 10px 0;">
      <div v-if="this.dtesLen !== 0">
        标的
        <el-autocomplete
          style="width: 200px;margin-right: 20px;"
          v-model="tickerInput"
          clearable
          :fetch-suggestions="querySearchTicker"
          placeholder="请输入内容"
          @select="tickerSelect('ticker')"
          @clear="tickerClear('ticker')"
        >
          <template slot-scope="{ item }">
            <div class="name">{{item.value}}</div>
          </template>
          <el-button slot="append" icon="el-icon-search" @click="tickerSelect('ticker')"></el-button>
        </el-autocomplete>
        日期
        <el-autocomplete
          style="width: 200px;"
          v-model="dateInput"
          clearable
          :fetch-suggestions="querySearchDate"
          placeholder="请输入内容"
          @select="tickerSelect('date')"
          @clear="tickerClear('date')"
        >
          <template slot-scope="{ item }">
            <div class="name">{{item.value}}</div>
          </template>
          <el-button slot="append" icon="el-icon-search" @click="tickerSelect('date')"></el-button>
        </el-autocomplete>
      </div>
      <div class="font_s_14 align_right">
        <span class="copyClass" ref="copyRef" @click="copySearch($event)">&nbsp;&nbsp;</span>
        <i @click="handleCopy($event)" class="el-icon-document-copy cursor">拷贝数据</i>
      </div>
    </div>
    <div id="grid">
      <vxe-grid
        border
        show-overflow
        show-header-overflow="title"
        ref="xGrid"
        height="400"
        row-id="date"
        :checkbox-config="{checkField: 'checked', labelField: 'date'}"
        :loading="loading">
      </vxe-grid>
    </div>
  </div>
</template>
<script>
// import { getRequest } from '@/api/dailyBackTest.js'
import clip from '@/utils/clipboard'
export default {
  props: ['detailData', 'date', 'hideZero', 'hideNan'],
  data () {
    return {
      loading: false,
      list: [], // 上万条总数据
      clist: [], // 页面展示数据
      viewW: '', // 外部box宽度
      itemW: 140, // 单项宽度
      offsetX: 0, // 动态偏移量
      // scrollw: '', // 整个滚动列表高度
      showNum: '', // 可视化高度一次能装几个列表
      obtainTop: '', // 获取的数据位置
      obtainLeft: '',
      tablesData: [],
      dateList: [],
      dtesLen: undefined,
      tkrsLen: 0,
      tickerInput: '',
      dateInput: '',
      allColumn: [],
      allData: [],
      searchList: [],
      dimension: ''
    }
  },
  created () {
    // 动态定义，阻断 vue 对大数据双向绑定，提升加载速度
    this.allData = []
    this.allColumn = []
    if (!this.detailData._id) {
      return
    }
    this.title = this.detailData.index_title
    this.searchList = [this.title]
    this.updataTable()
  },
  mounted () {
    this.lastTime = new Date().getTime()
    this.widthLenght = this.width
    this.viewW = this.view
    if (this.date) {
      this.dateInput = this.date
    }
  },
  watch: {
    detailData (newVal, oldVal) {
      this.detailData = newVal
      this.allData = []
      this.allColumn = []
      if (!this.detailData._id) {
        return
      }
      this.title = this.detailData.index_title
      this.searchList = [this.title]
      this.updataTable()
    },
    hideZero (newVal, oldVal) {
      this.hideZero = newVal
      if (oldVal !== null) {
        this.updataTable()
      }
    },
    hideNan (newVal, oldVal) {
      this.hideNan = newVal
      if (oldVal !== null) {
        this.updataTable()
      }
    },
    date (newVal, oldVal) {
      this.dateInput = newVal
      if (newVal.length > 0) {
        if (this.allData.length > 0) {
          this.tickerSelect('date')
        }
      }
    }
  },
  methods: {
    updataTable () {
      let labels = this.detailData.labels
      let values = this.detailData.values
      if (this.detailData.all_labels) {
        labels = this.detailData.all_labels
        values = this.detailData.all_values
      }
      let valueData = values
      let labelData = labels
      if (this.hideNan) {
        valueData = values.filter(da => da !== null)
      }
      if (this.hideZero) {
        valueData = valueData.filter(da => da !== 0)
      }
      if (this.hideZero || this.hideNan) {
        labelData = []
        for (let j = 0; j < values.length; j++) {
          if (values[j] !== 0 && values[j] !== null) {
            labelData.push(labels[j])
          } else if (!this.hideNan && values[j] === null) {
            labelData.push(labels[j])
          } else if (!this.hideZero && values[j] === 0) {
            labelData.push(labels[j])
          }
        }
      }
      this.tablesData = valueData
      this.dateList = labelData
      this.init()
    },
    copySearch (event) {
      // clip(this.copyText, event)
    },
    handleCopy (event) {
      let text = '日期\t' + this.title + '\t'
      for (let i = 0; i < this.dateList.length; i++) {
        text = text + '\n' + this.dateList[i] + '\t'
        if (this.tablesData[i] !== null) {
          text = text + this.tablesData[i] + '\t'
        } else {
          text = text + '\t'
        }
      }
      this.copyText = text
      clip(this.copyText, event)
    },
    tickerClear (key) {
      let tickerLenght
      let dateLenght
      if (key === 'ticker') {
        tickerLenght = 0
      }
      if (key === 'date') {
        dateLenght = 0
      }
      if (dateLenght !== undefined || tickerLenght !== undefined) {
        this.select(dateLenght, tickerLenght)
      }
    },
    tickerSelect (key) {
      // console.log(key, this.tickerInput, this.dateInput)
      let tickerLenght
      let dateLenght
      var resultTicker = this.tickerInput ? this.searchList.filter(this.createFilter(this.tickerInput)) : this.searchList
      var resultData = this.dateInput ? this.dateList.filter(this.createFilter(this.dateInput)) : this.dateList
      if (key === 'ticker') {
        if (resultTicker.length > 0) {
          let index = this.searchList.indexOf(resultTicker[0])
          if (index > -1) {
            tickerLenght = index
          }
        } else {
          this.$message.error('没有该条数据！')
        }
        if (this.dateInput) {
          let index = this.dateList.indexOf(resultData[0])
          if (index > -1) {
            dateLenght = this.dateList.length - index - 1
          }
        }
      }
      if (key === 'date') {
        if (resultData.length > 0) {
          let index = this.dateList.indexOf(resultData[0])
          if (index > -1) {
            dateLenght = this.dateList.length - index - 1
          }
        } else {
          this.$message.error('没有该条数据！')
        }
        if (this.tickerInput) {
          let index = this.searchList.indexOf(resultTicker[0])
          if (index > -1) {
            tickerLenght = index
          }
        }
      }
      if (dateLenght !== undefined || tickerLenght !== undefined) {
        this.select(dateLenght, tickerLenght)
      }
    },
    select (dateLenght, tickerLenght) {
      this.$refs.xGrid.scrollTo(tickerLenght * 140, dateLenght * 48)
    },
    querySearchTicker (queryString, cb) {
      var results = []
      var restaurants = this.searchList
      var result = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // console.log(result)
      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          results.push({value: result[i]})
        }
      }
      cb(results)
    },
    querySearchDate (queryString, cb) {
      var results = []
      var restaurants = this.dateList
      var result = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          results.push({value: result[i].toString()})
        }
      }
      cb(results)
      return results
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.toString().toLowerCase().indexOf(queryString.toString().toLowerCase()) > -1)
      }
    },
    init () {
      Promise.all([
        this.findColumnList(100).then(data => {
          // console.log(data)
          this.allColumn = data
          this.$refs.xGrid.loadColumn(this.allColumn)
        }),
        this.findDataList(150).then(data => {
          // console.log(data)
          this.allData = data
          this.$refs.xGrid.loadData(this.allData)
          // console.log(this.allData)
        })
      ]).then(() => {
        this.loading = false
        this.viewW = document.getElementById('grid').scrollWidth - 15
        this.widthLenght = Math.ceil(this.viewW / 140) - 1
        if (this.dateInput) {
          setTimeout(() => {
            this.tickerSelect('date')
          }, 200)
        }
        // console.log(this.viewW)
      })
    },
    findColumnList (size) {
      return new Promise(resolve => {
        setTimeout(() => {
          var columns = []
          columns[0] = {
            field: 'date',
            title: '',
            width: 140
          }
          columns[1] = {
            field: 'title',
            title: this.title,
            width: 140
          }
          resolve(columns)
        }, 0)
      })
    },
    findDataList (size) {
      return new Promise(resolve => {
        setTimeout(() => {
          var list = []
          for (var index = this.dateList.length - 1; index >= 0; index--) {
            let item = { date: this.dateList[index] }
            if (this.tablesData[index] === null) {
              item['title'] = '-'
            } else {
              item['title'] = this.tablesData[index]
            }
            list.push(item)
          }
          resolve(list)
        }, 250)
      })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/timeSeries/vxeTableOne.vue